module.exports = __webpack_public_path__ + "static/oegb2-c29eaec36ec3195a3b75152276e974f7.png";